import React, { useContext, useEffect } from "react";
import Stack from "src/components/Stack/Stack";
import { AuthContext } from "src/contexts/AuthContext";
import { Button, HollowButton, MainContainer, Title } from "../../components";
import Config from "../../config";
import { ThemeContext } from "../../contexts/ThemeContext";
import { sendEvent } from "../../hooks/analytics";
import {
  Container,
  ContainerButton,
  MessageDescription,
  TextLabel
} from "./../styles";
import { SuccessIcon } from "./Icon";
import { GloboHelpButton } from "src/components/GloboHelpButton";

export function Success() {
  const { authenticate } = useContext(AuthContext);

  useEffect(() => {
    authenticate();
  }, []);

  const { setHeaderReturn, setHeaderUser } = useContext(ThemeContext);
  setHeaderReturn(true);
  setHeaderUser(true);

  const redirectUrl =
    localStorage.getItem("callbackUrl") || "https://globo.com";
  const globoId = localStorage.getItem("globoId") || "";
  const providerName = localStorage.getItem("providerName") || "";

  useEffect(() => {
    sendEvent(
      "alf_page_view",
      {
        user_code_provider_hit: "cadun",
        page_name_custom: "sucesso_na_associacao",
        provider_name: providerName
      },
      { user_code: globoId, user_code_provider: "cadun" }
    );
  }, [globoId, providerName]);

  const redirectTo = () => {
    sendEvent(
      "component_click",
      {
        component_name: "ir_para_conteudo",
        component_type: "button",
        component_item_link_redirect: redirectUrl,
        page_name_custom: "sucesso_na_associacao",
        provider_name: providerName
      },
      {
        user_code: globoId,
        user_code_provider: "cadun"
      }
    );

    window.location.href = redirectUrl;
  };

  return (
    <MainContainer>
      <Container>
        <Stack
          direction={{ mobile: "column", desktop: "row" }}
          spacing={{ mobile: 16, desktop: 24 }}
          alignItems={"center"}
        >
          <SuccessIcon />
          <Title>Tudo pronto!</Title>
        </Stack>
        <MessageDescription>
          <TextLabel>
            Você já pode acessar o conteúdo disponível no Globoplay conforme a
            sua assinatura na {providerName}.
          </TextLabel>
        </MessageDescription>
      </Container>
      <ContainerButton>
        <Button onClick={redirectTo}>Ir para o conteúdo</Button>
        <GloboHelpButton
          pageNameCustom={"sucesso_na_associacao"}
          providerName={providerName}
          globoId={globoId}
        />
      </ContainerButton>
    </MainContainer>
  );
}

export default Success;
